// extracted by mini-css-extract-plugin
export default {"columns":"LandingPage_columns__lyGD8","activityBtn":"LandingPage_activityBtn__gKcD8","travelGuide":"LandingPage_travelGuide__e1XIy","sidebarCol":"LandingPage_sidebarCol__FCGGO"};